import React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";

// Disable Ant Design wave effect before importing App
import "./disableWave";

import App from "./App";

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined;
// VITE_SENTRY_ENVIRONMENT permite distinguir issues de staging vs prod
// aunque el bundle se construya con `vite build` en ambos (MODE='production').
// Sin esta variable cae en MODE, que es 'development' en `vite` y 'production'
// en `vite build`.
const SENTRY_ENVIRONMENT =
  (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) ??
  import.meta.env.MODE;

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: Number(
      import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? '0.1',
    ),
    replaysSessionSampleRate: Number(
      import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE ?? '0.02',
    ),
    replaysOnErrorSampleRate: 1.0,
  });
}

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
